import { Link, useLocation } from "react-router-dom";
import { smallBold, typoBase } from "../styles/typography";
import { AppBar, Box, Tab, Tabs } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

const TabsBar = ({ setCurrentTab }) => {
  const { t } = useTranslation('navigation');
  const location = useLocation();
  const { id, tab } = useParams();
  const [activeTab, setActiveTab] = useState(
    location.pathname.split("/").pop()
  );

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
    setCurrentTab(newValue);
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#fff",
        boxShadow: "none",
        marginTop: "10px",
        marginBottom: "0",
      }}
    >
      <Box >
        <Tabs
          value={activeTab}
          onChange={handleChange}
          textColor="inherit"
          indicatorColor="#2B80B6"
          sx={{
            minHeight: "32px",
            height: "32px",
            width: "100%",
            // backgroundColor: "blue",
            "& .MuiTab-root": {
              ...typoBase,
              color: "black",
              fontFamily:
                "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
              fontSize: "10.5px",
              fontWeight: 400,
              // height: "15.75px",
              // lineHeight: "15.75px",
              borderBottom: "1px solid #d1d1d1",
              minHeight: "32px",
              height: "32px",
              textTransform: "capitalize",
            },
            "& .Mui-selected": {
              ...smallBold,
              color: "#2B80B6",
              fontFamily:
                "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
              fontSize: "10.5px",
              fontWeight: 400,
              borderBottom: "1px solid #2B80B6",
              zIndex: 1
            },
          }}
        >
          {[
            "overview",
            "parties",
            "documents",
            "emails",
            "calendar",
            "tasks",
            "timesheets",
            "disbursements",
            "finance",
            "notes",
            "",
            "",
            "",
          ].map((tab) => (
            <Tab
              key={tab}
              label={tab ? t(`tabs.${tab}`) : ""}
              value={tab}
              component={Link}
              to={`/files/${id}/${tab}`}
              sx={{
                padding: "0",
                margin: "0",
                minHeight: "32px",
                height: "32px",
                width: tab === "" ? "5px" : "50px",
              }}
            />
          ))}
        </Tabs>
      </Box>
    </AppBar>
  );
};

export default TabsBar;
